import {
  GET_NOTICE_LIST,
  GET_NOTICE_LIST_RESPONCE,
  GET_NOTICE_TOTALS,
  GET_NOTICE_TOTALS_RESPONCE,
  ADD_NOTICE,
  EDIT_NOTICE,
  DELETE_NOTICE,
  CHANGE_STATUS_NOTICE,
  CHNAGE_NOTICE_STATUS_REDUX_STATE,
  NOTICE_VIEW_REPORT,
  NOTICE_VIEW_REPORT_RESPONCE,
} from "./actionTypes";


/**
 * Returns an action object to get the driver list.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, success, and failure properties.
 */
export const getNoticeList = (data, success, failure) => {
  return {
    type: GET_NOTICE_LIST,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
 }

 /**
  * Creates an action object for the driver list response.
  * @param {any} data - The data payload for the action.
  * @returns {Object} An action object with the type and payload.
  */
 export const getNoticeListResponce = data => {
  return {
    type: GET_NOTICE_LIST_RESPONCE,
    payload: data,
  }
}

/**
 * Returns an action object to get the notice totals.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, success, and failure properties.
 */
export const getNoticeTotals = (data, success, failure) => {
  return {
    type: GET_NOTICE_TOTALS,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object for the notice totals response.
 * @param {any} data - The data payload for the action.
 * @returns {Object} An action object with the type and payload.
 */
export const getNoticeTotalsResponce = data => {
  return {
    type: GET_NOTICE_TOTALS_RESPONCE,
    payload: data,
  }
}

/**
 * Creates an action object to add a notice.
 * @param {any} data - The data to be added as a notice.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const addNotice = (data, success, failure) => {
  return {
    type: ADD_NOTICE,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}


/**
 * Action creator function for editing a notice.
 * @param {string} id - The ID of the notice to edit.
 * @param {object} data - The updated data for the notice.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with the type, payload, success, and failure properties.
 */
export const editNotice = (id, data, success, failure) => {
  return {
    type: EDIT_NOTICE,
    payload: {id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Creates an action object to delete a notice.
 * @param {string} id - The ID of the notice to delete.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const deleteNotice = (id, success, failure) => {
  return {
    type: DELETE_NOTICE,
    payload: { id },
    success: (data) => success(data),
    failure: (data) => success(data),
  }
}

/**
 * Creates an action object to change the status notice.
 * @param {string} id - The ID of the notice.
 * @param {any} data - The data to update the notice with.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const changeStatusNotice = (id, data, success, failure) => {
  return {
    type: CHANGE_STATUS_NOTICE,
    payload: {id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Action creator function to edit the notice status in the Redux state.
 * @param {any} data - The data to be passed as the payload of the action.
 * @returns {object} - An action object with the type and payload.
 */
export const editNoticeStatusReduxState = (data) => {
  return {
    type: CHNAGE_NOTICE_STATUS_REDUX_STATE,
    payload: data,
  }
}


/**
 * Returns an action object for getting a notice view report.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type and callback functions.
 */
export const getNoticeViewReport = (id, data, success, failure) => {
  return {
    type: NOTICE_VIEW_REPORT,
    payload: { id, data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
 }

 /**
  * Creates an action object for the NOTICE_VIEW_REPORT_RESPONCE action type with the given data as the payload.
  * @param {any} data - The data to be included in the payload of the action.
  * @returns {Object} An action object with the type NOTICE_VIEW_REPORT_RESPONCE and the given data as the payload.
  */
 export const getNoticeViewReportResponce = data => {
  return {
    type: NOTICE_VIEW_REPORT_RESPONCE,
    payload: data,
  }
}

// In your actions file, ensure getNoticeReportData follows the same pattern as getNoticeViewReport
export const getNoticeReportData = (id, data, success, failure) => {
  return {
    type: 'GET_NOTICE_REPORT_DATA', // Add this to your actionTypes
    payload: { id, data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

